import SprintReport from './SprintReport';

export default SprintReport;
